import accessLocalStorage from '../accessLocalStorage';
import { decodeJwtPayload } from '../session';

export const getCcv2ApiBase = async () => {
  const envBase = process.env.REACT_APP_CALLCENTER_V2_BASE_URL;
  if (envBase) return envBase;
  const { ipRequest } = accessLocalStorage.getUserLocalStorage();
  const ipClean = ipRequest.split('/')[2];
  const host = ipClean.split(':')[0];
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  return `${protocol}//${host}`;
};

export const getCcv2TenantId = () => {
  const { user: { idtenant } } = accessLocalStorage.getUserLocalStorage();
  return String(idtenant);
};

export const getCcv2Token = () => {
  const { token } = accessLocalStorage.getUserLocalStorage();
  return token;
};

export const getCcv2CurrentUser = () => {
  const stored = accessLocalStorage.getUserLocalStorage();
  const user = stored?.user || {};
  const payload = decodeJwtPayload(stored?.token);
  const data = payload?.data || payload;

  const jwtRole = data?.role ?? payload?.role ?? 'user';
  const jwtAgentKey = data?.agentKey ?? payload?.agentKey ?? null;
  const jwtUserId = data?.userId ?? payload?.userId ?? payload?.sub ?? null;

  const role = jwtRole || user.role || user.user_role || 'user';

  return {
    userId: jwtUserId,
    role,
    agentKey: jwtAgentKey,
    idtenant: String(user.idtenant || ''),
    username: user.username || user.name || '',
    isManager: role === 'manager' || role === 'admin' || role === 'root',
    isRoot: role === 'root',
  };
};

export const isPhase5Enabled = () => {
  const stored = localStorage.getItem('ccv2_phase5_ui');
  if (stored !== null) {
    return stored === 'true';
  }
  try {
    const u = getCcv2CurrentUser();
    return u.isRoot || u.idtenant === 'vgs' || u.idtenant === '1';
  } catch (_e) {
    return false;
  }
};

export const ccv2Fetch = async (path, options = {}) => {
  const base = await getCcv2ApiBase();
  const token = getCcv2Token();
  const tenantId = getCcv2TenantId();

  const sep = path.includes('?') ? '&' : '?';
  const url = `${base}${path}${sep}tenant=${tenantId}`;

  const res = await fetch(url, {
    ...options,
    headers: {
      'Authorization': `Bearer ${token}`,
      'x-tenant-id': tenantId,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  if (!res.ok) {
    const errBody = await res.json().catch(() => ({ message: res.statusText }));
    const err = new Error(errBody.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.body = errBody;
    throw err;
  }

  if (res.status === 204) return null;
  return res.json();
};
